exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#translates{padding:20px}#translates li{font-weight:700}#translates li:hover{cursor:pointer}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./frontend/components/translates/translates.styl
 ** module id = 236
 ** module chunks = 0
 **/